import { render, staticRenderFns } from "./choose_partner_surprise.vue?vue&type=template&id=22369f8c&scoped=true&"
import script from "./choose_partner_surprise.vue?vue&type=script&lang=js&"
export * from "./choose_partner_surprise.vue?vue&type=script&lang=js&"
import style0 from "./choose_partner_surprise.vue?vue&type=style&index=0&id=22369f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22369f8c",
  null
  
)

export default component.exports